/* eslint-disable  */
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Typography,
  Tab,
  Tabs,
  Badge,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import AddCircleOutlineSharpIcon from '@material-ui/icons/AddCircleOutlineSharp';
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { OpenInNewOutlined } from '@material-ui/icons';
import useLogin from '../../../../src/hooks/useAuth';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/images/PhoneIcon.svg';

import { SectionUserInfo } from '../../../components/Common';
import { ReactComponent as WebsiteIcon } from '../../../assets/images/WebsiteIcon.svg';

import useCommunityList from '../../../hooks/useCommunityList';
import CommunityAddHealthFacility from '../CommunityDetails/CommunityAddHealthFacility/CommunityAddHealthFacility';
import { allowEditInsights, checkIfLoggedIn, formatNumberUS } from '../../../utils/Helper';
import { set } from 'lodash';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const Healthcare = (props) => {
  const [healthFacility, setHealthFacility] = useState([]);

  const [communityDetails, setCommunityDetails] = useState(props.communityInfo);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [isAccessible, setIsAccessible] = useState(false);
  const [repDetails, setRepDetails] = useState();
  const [healthcareTabData, setHealthcareTabData] = useState([]);
  const [healthcareCategoryCounts, setHealthcareCategoryCounts] = useState([]);
  const { getUserDataToAdmin } = useLogin();
  const isMobileOrTabletPortrait = window.innerWidth <= 992;
  const [facilityCount, setFacilityCount] = useState(0);
  const [categoryCount, setCategoryCount] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs')); // Or 'sm'

  // Infinite scroll state
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [loadedCount, setLoadedCount] = useState(0);

  // Prevent multiple simultaneous API calls
  const [isApiCallInProgress, setIsApiCallInProgress] = useState(false);
  const scrollTimeoutRef = useRef(null);
  const facilitiesContainerRef = useRef(null);

  const buttonRef = useRef(null);

  const {
    getCommunityHealthFacility,
    getRoleDescription,
    getUserName,
    getHealthcareFacilityCategoryCounts,
    getCommunityHealthCareFacilitiesByType,
  } = useCommunityList();

  const { getRoleData } = useLogin();

  const navigate = useNavigate();
  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const params = useParams();
  let communityID = params?.id;

  const key = 'iFrasCwdJh';
  let bytes = null;

  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } else {
    // window.location.hash = '#/app/home-page';
  }
  console.log(loggedInUserData, 'COMMU_ID');
  const [userId] = useState(loggedInUserData?.id);

  const [isEditing, setIsEditing] = useState(false);

  const insightUpdateId = communityDetails?.healthInsights[0]?.repId;

  const getHealthCareFacilitiesByType = async (page = 1, facilityTypeId) => {
    try {
      const resp = await getCommunityHealthCareFacilitiesByType({
        communityId: params?.id,
        facilityTypeId,
        page,
        limit: 20,
      });

      // Append new facilities
      setHealthcareTabData((prev) => {
        const newItems = resp.facilities.filter((f) => !prev.some((p) => p.id === f.id));
        return page === 1 ? resp.facilities : [...prev, ...newItems];
      });

      // Use pagination info from API
      const { totalPages, currentPage: respPage, pageSize } = resp.pagination;
      setTotalCount(resp.healthFacilityCount);
      setCurrentPage(respPage);
      setHasMore(respPage < totalPages); // true if more pages available
      // total number of facilities
    } catch (err) {
      console.error('Error fetching facilities:', err);
    }
  };

  const getAllHealthCareFac = async () => {
    const resp = await getHealthcareFacilityCategoryCounts({
      communityId: params?.id,
    });

    if (!resp.data || resp.data.length === 0) {
      console.log('No facility categories found');
      return; // Exit early if no data
    }
    //setTotalCount(resp.healthFacilityCount);
    setCategoryCount(resp.categoryCount);
    setHealthcareCategoryCounts(resp.data);
    console.log(resp, 'RESP22222');

    // Load facilities for the first category
    getHealthCareFacilitiesByType(currentPage, resp.data[0].id);
  };

  const handleEditClick = (facility) => {
    setSelectedFacility(facility);

    //console.log(facility);
    setIsEditing(true); // Set the editing state to true
    //console.log(facility.id);
    // Pass facility data through navigation state to avoid extra API call
    navigate(`/app/community-edit-health-facility/${communityDetails?.id}/${facility.id}`, {
      state: { facilityData: facility },
    });
  };

  // Function to handle adding, set isEditing to false when adding a new facility
  const handleAdd = () => {
    setIsEditing(false);
  };

  //console.log(selectedFacility, 'SSS');

  useEffect(() => {
    getAllHealthCareFac();
  }, []);

  const formatPhoneNumber = (phoneNumber) => {
    const digits = phoneNumber?.replace(/\D/g, '');
    return digits?.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
  };

  const [filterFacilityType, setFilterFacilityType] = useState(null);
  const [selectedFacilityTypes, setSelectedFacilityTypes] = useState([]);
  const [filteredFacilities, setFilteredFacilities] = useState(healthFacility);
  const [originalHealthFacility, setOriginalHealthFacility] = useState([]);
  const [collapseStates, setCollapseStates] = useState({});

  // New state for API-level category filtering
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [categoryFilterActive, setCategoryFilterActive] = useState(false);

  const handleFacilityTypeCollapse = (facilityType) => {
    setCollapseStates((prevCollapseStates) => ({
      ...prevCollapseStates,
      [facilityType]: !prevCollapseStates[facilityType],
    }));
  };

  //console.log(filteredFacilities, 'FNF');

  const comRepId = communityDetails?.healthFacility?.[0]?.repId;
  //console.log(comRepId, 765);

  // Handle category selection with fresh API call

  // Clear category filter and load all facilities

  // FlatList scroll handler - only triggers within FlatList container
  const handleFlatListScroll = useCallback(
    (event) => {
      const target = event.target;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

      if (distanceFromBottom < 100 && !loading && !isApiCallInProgress && hasMore) {
        console.log('🚀 Near bottom - loading next page');

        // Mark API as in-progress immediately
        setIsApiCallInProgress(true);

        // Call API with currentPage + 1; API function will update currentPage
        getHealthCareFacilitiesByType(currentPage + 1, selectedFacilityId).finally(() =>
          setIsApiCallInProgress(false),
        );
      }
    },
    [currentPage, loading, isApiCallInProgress, hasMore],
  );

  // Update original health facility when health facility changes
  useEffect(() => {
    setOriginalHealthFacility(healthFacility);
  }, [healthFacility]);

  const handleFilterClick1 = (facilityType) => {
    setSelectedFacilityTypes((prevSelected) => {
      const updatedSelected = prevSelected.includes(facilityType)
        ? prevSelected.filter((selected) => selected !== facilityType)
        : [...prevSelected, facilityType];

      return updatedSelected;
    });

    // Remove focus to immediately visually reflect the selection or deselection
    document.activeElement.blur();
  };

  const resetFilters = () => {
    setSelectedFacilityTypes([]);
    // Reset filteredFacilities to the same data as healthFacility
    setFilteredFacilities({ ...healthFacility }); // Make a shallow copy
    setAnchorEl(null);
  };

  const seeResults = () => {
    // Apply filtering logic to generate filteredData
    const filteredData = {};

    if (selectedFacilityTypes.length === 0) {
      // No filters selected, use the original data
      setFilteredFacilities({ ...healthFacility });
      // setFilteredResultsCount(numberOfEntries);
    } else {
      selectedFacilityTypes.forEach((facilityType) => {
        if (healthFacility.hasOwnProperty(facilityType)) {
          filteredData[facilityType] = healthFacility[facilityType];
        }
      });

      // Update filteredFacilities with the filteredData
      setFilteredFacilities(filteredData);
    }
  };

  // ... (other code)

  useEffect(() => {
    // Initialize filteredFacilities with the original healthFacility data
    setFilteredFacilities(healthFacility);
  }, [healthFacility]);

  const filteredResultsCount =
    selectedFacilityTypes?.length > 0
      ? selectedFacilityTypes.reduce((count, selectedType) => {
          return count + (healthFacility[selectedType]?.length || 0);
        }, 0)
      : 0;

  let numberOfEntries = 0;
  // const keys = Object.keys(healthFacility);

  // // Checking if the keys are arrays and getting their lengths
  // keys.forEach((key) => {
  //   if (Array.isArray(healthFacility[key])) {
  //     numberOfEntries += healthFacility[key].length;
  //   }
  // });

  const handleFilterButtonClick = (facilityType) => {
    setSelectedFacilityTypes((prevSelected) => {
      const updatedSelected = prevSelected.includes(facilityType)
        ? prevSelected.filter((selected) => selected !== facilityType)
        : [...prevSelected, facilityType];

      // Apply filtering logic immediately
      const filteredData = {};
      if (updatedSelected.length === 0) {
        // No filters selected, use the original data
        setFilteredFacilities({ ...healthFacility });
      } else {
        updatedSelected.forEach((type) => {
          if (healthFacility.hasOwnProperty(type)) {
            filteredData[type] = healthFacility[type];
          }
        });
        setFilteredFacilities(filteredData);
      }

      // Focus on a different element to remove the active class
      document.activeElement.blur();

      return updatedSelected;
    });
  };

  const getRepDetails = async () => {
    try {
      if (communityDetails?.healthInsights[0]?.repId) {
        const userDataResult = await getUserDataToAdmin({
          userIdd: communityDetails?.healthInsights[0]?.repId,
        });
        setRepDetails(userDataResult.usersResult);
      }
    } catch (error) {
      console.error('Async function error:', error);
    }
  };

  useEffect(() => {
    setIsAccessible(
      (props?.loggedInUserData?.id &&
        communityDetails?.userrole?.[0]?.id === props?.loggedInUserData?.id) ||
        props?.loggedInUserData?.roleId === 2,
    );
    getRepDetails();
  }, [communityDetails]);

  //console.log(props, '71771');

  const [value, setValue] = React.useState(0);
  const [selectedFacilityId, setSelectedFacilityId] = useState(null);
  const handleChange = (event, newValue) => {
    setSelectedFacilityId(healthcareCategoryCounts[newValue]?.id);
    setValue(newValue);
    getHealthCareFacilitiesByType(1, healthcareCategoryCounts[newValue]?.id);
  };
  return (
    <Paper className="WhitePaper" component="div">
      <Grid container>
        <Grid item xs={12} className="BoxHeadingContainer">
          <Typography color="primary" variant="h2" className="BoxHeading">
            Healthcare
          </Typography>
          <If
            condition={
              communityDetails?.healthInsights &&
              communityDetails?.healthInsights.length > 0 &&
              communityDetails?.healthInsights.sort(
                (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
              )[0]?.healthCareDesc !== ''
            }
          >
            <If
              condition={
                isAccessible &&
                !props?.publicView &&
                allowEditInsights(communityDetails, loggedInUserData)
              }
            >
              <Button
                type="submit"
                className="EditCommonButton LinkTypeButton"
                startIcon={<EditPenIconGreen />}
                size="small"
                color="primary"
                href={'/#/app/community-details-health-insights/' + communityDetails?.id}
              >
                Edit
              </Button>
            </If>
          </If>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={6} className="AutoWidth CDTotal">
          <Box className="CommonDetailBoxGrid">
            <Typography variant="h4" component="div" className="CDNumber">
              {formatNumberUS(totalCount)}
            </Typography>
            <Typography variant="body2" component="div">
              Facilities {loading && '(Loading...)'}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} className="AutoWidth">
          <Box className="CommonDetailBoxGrid">
            <Typography variant="h4" component="div" className="CDNumber">
              {formatNumberUS(categoryCount)}
            </Typography>
            <Typography variant="body2" component="div">
              Categories of Care
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <If condition={isAccessible && !props?.publicView}>
          <Box mt={2}>
            <Button
              className="AddButtonBox"
              variant="outlined"
              color="primary"
              fullWidth
              // href="community-add-health-facility"
              href={'/#/app/community-add-health-facility/' + communityDetails?.id}
              onClick={handleAdd}
              startIcon={<AddCircleOutlineSharpIcon />}
            >
              Add a healthcare facility
            </Button>
          </Box>
        </If>
        <Divider className="DividerCD"></Divider>
      </Grid>
      {console.log(healthcareCategoryCounts, 'healthcareTabData')}
      {healthcareCategoryCounts.length > 0 && (
        <Grid item xs={12} className="FacilityListAccordionContainer">
          <Box className="HealthcareListContent TabsContainer" ref={facilitiesContainerRef}>
            <Box className="TabsBox">
              <Box p={2}>
                <Typography variant="h6" color="primary">
                  Categories of Care
                </Typography>
                <Typography variant="caption" className="ListSubLabel">
                  Sorted by highest number of facilities found
                </Typography>
              </Box>
              <Tabs
                // orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs from API"
                orientation={isMobileOrTabletPortrait ? 'horizontal' : 'vertical'}
              >
                {healthcareCategoryCounts.map(
                  (tab, index) => (
                    console.log(tab, '0000000000'),
                    (
                      <Tab
                        key={index}
                        label={
                          <Badge badgeContent={tab.count} color="secondary" overlap="circular">
                            <Box className="TabTextName">{tab.label}</Box>
                          </Badge>
                        }
                        {...a11yProps(index)}
                      />
                    )
                  ),
                )}
              </Tabs>
            </Box>
            {healthcareCategoryCounts?.map((tab, index) => (
              <TabPanel key={index} value={value} index={index} className="TabsContentBox">
                <Box className="ListContentWrapper">
                  <Box className="ListContentContainer">
                    <Typography variant="caption" component="div" className="ListContentHeading">
                      {formatNumberUS(tab.count)} ‘{tab.label}’{' '}
                      {tab.count === 1 ? 'facility' : 'facilities'}
                    </Typography>

                    <Box
                      className="FacilityFlatList"
                      style={{
                        maxHeight: '585px',
                        overflowY: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        padding: '10px',
                        backgroundColor: '#fafafa',
                      }}
                      onScroll={handleFlatListScroll}
                    >
                      {healthcareTabData.map((facility, idx) => (
                        <React.Fragment key={facility.id}>
                          <Box className="FacilityNameBox">
                            <Box className="FacilityContentWrapper">
                              <Box className="FacilityName">
                                {facility.facilityWebUrl ? (
                                  <a
                                    href={facility.facilityWebUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                                  >
                                    <span className="facility-text" style={{ color: '#486877' }}>
                                      {facility.facilityName}
                                    </span>
                                    <OpenInNewOutlined color="primary" />
                                  </a>
                                ) : (
                                  <span style={{ color: '#212121' }}>{facility.facilityName}</span>
                                )}
                              </Box>

                              <Box component="div" className="FacilityInfo">
                                <img
                                  src={require('../../../assets/images/map-pin.png').default}
                                  alt="Map Pin"
                                />
                                <Typography
                                  variant="caption"
                                  component="div"
                                  className="FacilityInfoContent"
                                >
                                  {facility.facilityAddress}
                                </Typography>
                              </Box>

                              {facility?.facilityPhone?.length > 0 && (
                                <Box component="div" className="FacilityInfo">
                                  <PhoneIcon />
                                  <Typography
                                    variant="caption"
                                    component="div"
                                    className="FacilityInfoContent"
                                  >
                                    {formatPhoneNumber(facility.facilityPhone)}
                                  </Typography>
                                </Box>
                              )}
                            </Box>

                            {checkIfLoggedIn() && !props?.publicView && props?.isAccessible && (
                              <Button
                                className="EditCommonButtonNew"
                                variant="outlined"
                                color="primary"
                                size="small"
                                startIcon={<EditPenIconGreen />}
                                onClick={() => handleEditClick(facility)}
                              >
                                Edit
                              </Button>
                            )}
                          </Box>
                          {/* Render loading indicator after the last facility */}
                          {idx === healthcareTabData.length - 1 &&
                            loading &&
                            hasMore &&
                            value === index && (
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  padding: '15px',
                                }}
                              >
                                <CircularProgress size={18} color="primary" />
                                <Typography style={{ marginLeft: '10px', fontWeight: 500 }}>
                                  Loading more {tab.label.toLowerCase()} facilities...
                                </Typography>
                              </Box>
                            )}
                        </React.Fragment>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </TabPanel>
            ))}
          </Box>
        </Grid>
      )}

      {/* </If> */}
      <Grid item xs={12} className="ChatBoxContainer ChatBoxHealthcare">
        <Box className="ChatBox CommonDetailBoxGrid">
          <If
            condition={
              // !props?.publicView &&
              communityDetails?.healthInsights &&
              communityDetails?.healthInsights.length > 0 &&
              communityDetails?.healthInsights.sort(
                (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
              )[0]?.healthCareDesc !== ''
            }
          >
            <Box className="ChatContent">
              <If
                condition={
                  isAccessible &&
                  !props?.publicView &&
                  communityDetails?.healthInsights?.find(
                    (x) => x.repId === communityDetails?.userrole[0]?.id || x.isAdminEntry,
                  )?.healthCareDesc
                }
              >
                {/* <Button
                  className="EditCommonButtonFloat"
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<EditPenIconGreen />}
                  href={'/#/app/community-details-health-insights/' + communityDetails?.id}
                >
                  Edit
                </Button> */}
              </If>
              {communityDetails?.healthInsights?.length > 0 && (
                <Typography variant="body2" className="ChatText">
                  {
                    communityDetails?.healthInsights.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
                    )[0]?.healthCareDesc // Sort by updatedAt in descending order // Accessing healthCareDesc property of the most recent object
                  }
                </Typography>
              )}
            </Box>
            {/* <SectionUserInfo
              communityDetails={communityDetails}
              isAdminEntry={false}
              aboutUser={communityDetails?.healthInsights?.[0]?.representative}
              getUserNameFunction={getUserName}
              getRoleDescriptionFunction={getRoleDescription}
            /> */}
            <SectionUserInfo
              communityDetails={communityDetails}
              repDetails={repDetails}
              isAdminEntry={communityDetails?.healthInsights?.[0]?.isAdminEntry}
              getUserNameFunction={getUserName}
            />
          </If>
        </Box>
      </Grid>

      <If condition={isAccessible && !props?.publicView}>
        <Grid item xs={12}>
          <If
            condition={
              (!communityDetails?.healthInsights?.length ||
                communityDetails?.healthInsights?.[0]?.healthCareDesc?.trim() === '') &&
              allowEditInsights(communityDetails, loggedInUserData)
            }
          >
            <Grid item xs={12}>
              <Box>
                <Typography variant="body2" className="InsightLabel">
                  Describe your community's healthcare. Are there any specialties or awards
                  facilities are known for?
                </Typography>
              </Box>
            </Grid>
            <Box className="Wrapper ButtonWrapper InsightButtonContainer">
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                href={'/#/app/community-details-health-insights/' + communityDetails?.id}
              >
                <Box className="AddButton">Add Insight</Box>
              </Button>
            </Box>
          </If>
        </Grid>
      </If>

      {/* Render the EditHealthFacility component only when editing is enabled */}
      {selectedFacility && comRepId !== undefined && (
        <CommunityAddHealthFacility
          comRepId={comRepId}
          editMode={isEditing} // Pass the edit mode flag
          initialValues={selectedFacility} // Pass the selected facility data for editing
        />
      )}
    </Paper>
  );
};

export default Healthcare;
